export function isDefined(value) {
  return typeof value !== 'undefined'
}

export function inArray(value, array) {
  return array.indexOf(value) !== -1
}

export function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(attribute =>
    element.setAttribute(attribute, attributes[attribute])
  )
  return element
}
